import { toBigInt } from 'ethers';
import env from './env';
import { isMobile } from 'react-device-detect';

const test = env.isTestMode;
const local = env.isLocal;

const NFT_PRESALE_SERVER_URL = test
  ? 'https://meta.service.test.perplay.io/api/NftPreSale'
  : 'https://meta.service.perplay.io/api/NftPreSale';

const SERVER_URL = test
    ? "https://meta.service.test.perplay.io"
    : local
        ? "https://211.193.0.223:8405"
        : "https://meta.service.perplay.io";

const HAVA_ENDPOINT = test
  ? 'https://ctz.vega.havah.io/api/v3'
  : 'https://ctz.havah.io/api/v3';

export const POLYGON_RPC_URI = test
  ? 'https://rpc-mumbai.maticvigil.com'
  : 'https://rpc-mainnet.maticvigil.com';

export const HAVASWAP_URI = test
  ? 'https://develop-havahswap.vercel.app/market/collection/'
  : 'https://havahswap.io/market/collection/';

export const NftContractAddress = test
  ? 'cx37436f078297be0702c8482e820bbe71cd7fd4ff'
  : 'cx71da4f9e8557a16e4c86833403109a96265ee4eb';

export const PolygonContractAddress = test
  ? '0x46f06Ff39A331A59C84C552ca17aDF402B28259A'
  : '0x1567704E1fAdb46Ab13c742f82D1C470e10ba21C';

export const seasonStatus = {
  saleScheduleTime: {
    OG_SALE_START: '2023-04-18T12:00:00.000Z',
    OG_SALE_END: '2023-04-19T12:00:00.000Z',
    WL_SALE_START: '2023-04-19T12:00:00.000Z',
    WL_SALE_END: '2023-04-19T14:30:00.000Z',
    PUBLIC_SALE_START: '2023-04-19T14:30:00.000Z',
    PUBLIC_SALE_END: '2030-04-29T06:25:00.000Z',
    REVEAL_START: '2023-04-21T05:00:00.000Z',
    ECOSYSTEM_SALE_START: '',
    ECOSYSTEM_SALE_END: '',
  },
  saleScheduleTitle: {
    OG_SALE_START: 'OG SALE STARTS IN',
    OG_SALE_END: 'OG SALE ENDS IN',
    WL_SALE_START: 'WL SALE STARTS IN',
    //"WL_SALE_END" : "WL SALE ENDS IN",
    WL_SALE_END: 'OG/WL NFTs AVAILABLE',
    PUBLIC_SALE_START: 'PUBLIC SALE STARTS IN',
    PUBLIC_SALE_END: 'PUBLIC SALE ENDS IN',
    ECOSYSTEM_SALE_START: 'ECOSYSTEM SALE STARTS IN',
    ECOSYSTEM_SALE_END: 'ECOSYSTEM SALE END',
  },
  saleQty: {
    OG: 1300,
    WL: 3011,
    PUBLIC: 0,
    ECO: 5200,
  },
  salePrice: {
    OG: 155,
    WL: 165,
    PUBLIC: 175,
  },
  saleId: {
    OG: 'OgSale',
    WL: 'WlSale',
    PUBLIC: 'PubSale',
  },
};

export const EXTERNAL_MARKET_URIS = {
  HAVAH: 'https://havahswap.io/launchpad',
  PALA: 'https://pala.io/launchpad',
  ALTAVA:
    'https://marketplace.altava.com/collections/0xcEAFed9EE4B274EE25D5aE36464E080C1369ebd1/networks/polygon',
  HYPER: 'https://hypermarket.gg/minting/perplay',
};

// ----------------------------
// 기어 판매 관련

export const PRESALE_API_URL = NFT_PRESALE_SERVER_URL;
export const SERVER_API_URL = SERVER_URL
export const HAVAH_RPC_URL = HAVA_ENDPOINT;

export const GEAR_SERVER_URL = test
  ? 'https://meta.service.test.perplay.io/api'
  : 'https://meta.service.perplay.io/api';

export const metaMaskDeepLink = test
  ? 'https://metamask.app.link/dapp/perplay-webapp-prod-dev.azurewebsites.net/gear'
  : 'https://metamask.app.link/dapp/perplay.io/gear';

export const chainId = test ? 80002 : 137;

export const mainNetDecimal = toBigInt('1000000');
export const testNetDeciaml = toBigInt('1000000000000000000');

export const gearGrade = {
  // normal: 'normal',
  rare: 'rare',
  elite: 'elite',
};

export const linkUrl01 =
  'https://chromewebstore.google.com/detail/havah-wallet/cnncmdhjacpkmjmkcafchppbnpnhdmon';
export const linkUrl02 = 'https://mitter.havah.io';
export const linkUrl03_KO =
  'https://play.google.com/store/apps/details?id=com.bbl.perplay';
export const linkUrl03_EN =
  'https://play.google.com/store/apps/details?id=com.bbl.perplay';
export const linkUrl04 =
  'https://perplay.notion.site/PERPLAY-GEAR-87ea04c1ef924daf89e91b578986118b';

// 모바일에서 사용할 홈페이지 풀 패스, PC에서는 ./gear를 사용한다.
export const homepageUrl = local
  ? 'http://localhost:3000/gear'
  : test
  ? 'https://perplay-webapp-prod-dev.azurewebsites.net/gear'
  : 'https://perplay.io/gear';

export const providerUrl = test
  ? 'https://polygon-amoy.g.alchemy.com/v2/QORWWIerP_dZbWTrVd55Y8ORbExQE-0Y'
  : 'https://polygon-mainnet.g.alchemy.com/v2/QORWWIerP_dZbWTrVd55Y8ORbExQE-0Y';

export const chartDataRefKey = 'chartData';
export const configRefKey = test ? 'gear/configDev' : 'gear/configProd';
export const maintenanceRefKey = test ? 'gear/maintenanceDev' : 'gear/maintenanceProd';
export const pilotDataRefKey = test || local ? 'pilot/dev' : 'pilot/prod';

const gearBgUrlDev = isMobile
  ? 'https://perplayblobdev.blob.core.windows.net/nft-storage/gear%5Cgear_bg_mobile.mp4'
  : 'https://perplayblobdev.blob.core.windows.net/nft-storage/gear%5Cgear_bg.mp4';

const gearBgUrlProd = isMobile
  ? 'https://perplayblobprod.blob.core.windows.net/nft-storage/gear%5Cgear_bg_mobile.mp4'
  : 'https://perplayblobprod.blob.core.windows.net/nft-storage/gear%5Cgear_bg.mp4';

export const gearBgUrl = test ? gearBgUrlDev : gearBgUrlProd;

const gearEliteIcon = test
  ? 'https://perplayblobdev.blob.core.windows.net/nft-storage/gear%5CGEAR100.mp4'
  : 'https://perplayblobprod.blob.core.windows.net/nft-storage/gear%5CGEAR100.mp4';
const gearRareIcon = test
  ? 'https://perplayblobdev.blob.core.windows.net/nft-storage/gear%5CGEAR10.mp4'
  : 'https://perplayblobprod.blob.core.windows.net/nft-storage/gear%5CGEAR10.mp4';
const gearNormalIcon = test
  ? 'https://perplayblobdev.blob.core.windows.net/nft-storage/gear%5CGEAR1.mp4'
  : 'https://perplayblobprod.blob.core.windows.net/nft-storage/gear%5CGEAR1.mp4';

export const gearIcons = {
  normal: gearNormalIcon,
  rare: gearRareIcon,
  elite: gearEliteIcon,
};

export const noticePopupImgs = {
  en: test
    ? 'https://perplayblobdev.blob.core.windows.net/nft-storage/gear%5Cimg_notice_popup_en.png'
    : 'https://perplayblobprod.blob.core.windows.net/nft-storage/gear%5Cimg_notice_popup_en.png',
  ko: test
    ? 'https://perplayblobdev.blob.core.windows.net/nft-storage/gear%5Cimg_notice_popup_ko.png'
    : 'https://perplayblobprod.blob.core.windows.net/nft-storage/gear%5Cimg_notice_popup_ko.png',
  ja: test
    ? 'https://perplayblobdev.blob.core.windows.net/nft-storage/gear%5Cimg_notice_popup_ja.png'
    : 'https://perplayblobprod.blob.core.windows.net/nft-storage/gear%5Cimg_notice_popup_ja.png',
};


// 파일럿 에어드랍
export const PilotContractAddress =
    test || local ?
        '0x24d78187029e630D46C60Fae1BA2C69A6A964979'
        : '0xAa63A3C3175806De19A7fC48FbCAFd9bb6aC5096'

export const PilotDeepLink =
    test || local ?
        `https://metamask.app.link/dapp/perplay-webapp-prod-temp.azurewebsites.net/pilot`
        : `https://metamask.app.link/dapp/perplay.io/pilot`

export const PilotChainId =
    test || local ?
        "0x66eee"
        : "0xa4b1"

export const PilotNetwork =
    test || local ?
        {
          chainId: '0x66eee',
          chainName: 'Arbitrum Sepolia',
          nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
          },
          rpcUrls: ['https://sepolia-rollup.arbitrum.io/rpc'],
          blockExplorerUrls: ['https://sepolia.arbiscan.io/'],
        }
        :
        {
          chainId: '0xa4b1', // 42161 (10진수)의 16진수
          chainName: 'Arbitrum One',
          nativeCurrency: {
            name: 'Ether',
            symbol: 'ETH',
            decimals: 18,
          },
          rpcUrls: ['https://arb1.arbitrum.io/rpc'],
          blockExplorerUrls: ['https://arbiscan.io/'],
        }